import { GameScene, IGameState } from '../IGameState';
import IPlayerData from '../../../Player/IPlayerData';
import { AsyncActionStatus } from '../../AsyncAction';
import { ThunkAction } from 'redux-thunk';
import { Action } from 'typesafe-actions';
import Game from '../../../Game';
import { DataConflictActions } from '../DataConflictActions';
import { hidePrioPopup, showPrioPopup } from '../../UI/UIStateHelper';
import { conflicts } from '../../../Utility/DataConflictsHelper';
import { createPlayerState } from '../../../Player/DataManager';
import GameStateHelper from '../GameStateHelper';

export function fetchConflicts(): ThunkAction<
    Promise<void>,
    IGameState,
    never,
    Action
> {
    return async (dispatch, getState) => {
        const { status } = getState().dataConflict;
        if (
            status !== AsyncActionStatus.COMPLETE &&
            status !== AsyncActionStatus.EMPTY
        ) {
            return;
        }
        dispatch(DataConflictActions.startFetchingConflicts());
        dispatch(
            DataConflictActions.setConflicts(
                await Game.sdk.driver.fetchDataConflicts()
            )
        );
    };
}

export function startFetching(state: IGameState): IGameState {
    return {
        ...state,
        dataConflict: {
            ...state.dataConflict,
            status: AsyncActionStatus.QUEUED,
        },
    };
}

export function setConflicts(
    state: IGameState,
    dataSets: IPlayerData[]
): IGameState {
    if (dataSets.length > 1) {
        return {
            ...state,
            // Show conflict resolution popup
            UIStatePrio: showPrioPopup(
                state.UIStatePrio,
                'resolveDataConflictMenu',
                {}
            ),
            // Start conflict resolution
            dataConflict: {
                status: AsyncActionStatus.IN_PROGRESS,
                result: dataSets,
            },
        };
    } else if (dataSets.length === 1) {
        // If there is only one set resolve using it
        return resolveConflicts(state, dataSets[0]);
    }
    // Complete conflict resolution if no conflicts
    return completeConflictResolution(state);
}
export function resolveConflicts(state: IGameState, result: IPlayerData) {
    // Hide conflict resolution popup
    state.UIStatePrio = hidePrioPopup(
        state.UIStatePrio,
        'resolveDataConflictMenu',
        {}
    );

    // Apply selected save only if it is different
    if (conflicts(Game.player.data.playerEndpointData, result)) {
        state.playerState = createPlayerState(result);
        // (Re)load world scene
        state = GameStateHelper.loadWorld(state, state.playerState.world, true);
    }

    // Complete conflict resolution
    state = completeConflictResolution(state);

    Game.player.data.flush(state, true);
    return state;
}

function completeConflictResolution(state: IGameState): IGameState {
    return {
        ...state,
        dataConflict: {
            status: AsyncActionStatus.COMPLETE,
            result: [],
        },
    };
}
